export default __webpack_public_path__ + "static/media/rolls-royce-ghost-bl-12.9d9ab72a.jpg";